import CustomModal, { ModalBody, ModalFooter, ModalHeader } from '@/components/shared/CustomModal'

const SelectDatasetDocumentsModal = ({ 
    selectDocumentsModal, 
    setSelectDocumentsModal, 
    dataSetDocuments, 
    markedDocuments, 
    setMarkedDocuments, 
}) => {
    
    const handleToggle = (isMarked, id) => {
        
        if (isMarked) {
            setMarkedDocuments(prev => prev.filter(docId => docId !== id))
        } else {
            setMarkedDocuments(prev => [...prev, id])
        }
    }
    
    return (
        <CustomModal
            open={() => selectDocumentsModal}
            modalHandler={() => setSelectDocumentsModal(!selectDocumentsModal)}>
            <ModalHeader>
                Select the documents to process
            </ModalHeader>
            <ModalBody>
                <ul className="space-y-2">
                    {dataSetDocuments.map(dsDoc => {
                        const isMarked = markedDocuments.includes(dsDoc.id)
                        
                        return (
                            <li
                                key={dsDoc.id}
                                className={'flex items-center p-2 rounded cursor-pointer bg-base-100'}
                                onClick={() => handleToggle(isMarked, dsDoc.id)}>
                                <input
                                    type="checkbox"
                                    checked={isMarked}
                                    onChange={() => handleToggle(isMarked, dsDoc.id)}
                                    className="mr-2"/>
                                <span>{dsDoc.name}</span>
                            </li>
                        )
                    })}
                </ul>
            
            </ModalBody>
            <ModalFooter>
                <button 
                    className="btn btn-primary"
                    onClick={() => setSelectDocumentsModal(!selectDocumentsModal)}>
                Save
                </button>
            </ModalFooter>
        </CustomModal>
        
    )
}

export default SelectDatasetDocumentsModal